<!--Implementação na View
    Componente:
    <auth-pin ref="pinComponent"></auth-pin>
    Botão:
    <b-button v-b-modal.ID-HERE @click="pinFoco()"></b-button>

    Desbloqueio via POST (ex.: Meus dados — PIN):
    <auth-pin ref="pinComponent" modal-id="user-profile-pin-modal"
        modal-title="Confirme seu PIN atual"
        :post-unlock-url="url"
        :expected-user-id="userId"
        @validated="onUnlocked" />
-->
<template>
    <b-modal :id="modalId" :title="modalTitle" centered hide-footer @shown="onModalShown">
        <div class="spinner-border text-primary" style="display:none;" role="status" id="auth-spinner">
            <span class="sr-only">Aguarde...</span>
        </div>
        <div class="alert alert-info" id="auth-success" style="display:none;"></div>
        <div v-if="error" class="alert alert-danger">{{ error }}</div>
        <div class="row" id="auth-form">
            <div class="col-12 mt-3 mb-3">
                <div class="input-group">
                    <input
                        :id="inputDomId"
                        ref="pinInput"
                        v-model="pin"
                        type="text"
                        name="authPin"
                        maxlength="4"
                        autocomplete="off"
                        class="form-control text-center"
                        style="text-security:disc; -webkit-text-security:disc;"
                        @keyup="pinKeyUp"
                    >
                    <span class="input-group-text">
                        <i class="bi bi-key-fill"></i>
                    </span>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
function csrfHeader() {
    const el = document.querySelector('meta[name="csrf-token"]');
    const token = el ? el.getAttribute('content') : '';
    return token ? { 'X-CSRF-TOKEN': token } : {};
}

export default {
    props: {
        modalId: {
            type: String,
            default: 'pin-modal',
        },
        modalTitle: {
            type: String,
            default: 'Informe seu PIN',
        },
        /** Se definido, envia POST com { current_pin } em vez de GET get-by-pin. */
        postUnlockUrl: {
            type: String,
            default: null,
        },
        /** Com postUnlockUrl: confere user_id da resposta com o usuário esperado. */
        expectedUserId: {
            type: Number,
            default: null,
        },
    },

    data() {
        return {
            pin: '',
            error: '',
        };
    },

    computed: {
        inputDomId() {
            return `${this.modalId}-pin-input`;
        },
    },

    mounted() {
        console.log('auth.pin loaded');
    },

    methods: {
        openModal() {
            this.pin = '';
            this.error = '';
            this.$bvModal.show(this.modalId);
        },

        onModalShown() {
            this.$nextTick(() => this.pinFoco());
        },

        pinFoco() {
            const el = this.$refs.pinInput;
            if (el && typeof el.focus === 'function') {
                el.focus();
            }
        },

        pinKeyUp(event) {
            this.error = '';
            if (event.key === 'Enter') {
                return false;
            }
            if (this.pin.length === 4) {
                return this.pinRequest();
            }
        },

        pinRequest() {
            if (this.postUnlockUrl) {
                return this.pinRequestPostUnlock();
            }
            const action = this.$parent.auth && this.$parent.auth.action ? this.$parent.auth.action : '';
            const url = `/ajax/user/get-by-pin?pin=${this.pin}${action ? '&action=' + encodeURIComponent(action) : ''}`;
            axios
                .get(url)
                .then((response) => this.pinResponse(response.data))
                .catch((error) => {
                    console.log(error);
                    this.pin = '';
                    this.error = 'Erro ao validar PIN. Tente novamente.';
                    setTimeout(() => this.pinFoco(), 200);
                });
        },

        pinRequestPostUnlock() {
            axios
                .post(this.postUnlockUrl, { current_pin: this.pin }, { headers: csrfHeader() })
                .then((response) => this.pinResponsePostUnlock(response.data))
                .catch((error) => {
                    console.log(error);
                    this.pin = '';
                    const msg = error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'Erro ao validar PIN. Tente novamente.';
                    this.error = msg;
                    setTimeout(() => this.pinFoco(), 200);
                });
        },

        pinResponsePostUnlock(data) {
            if (this.expectedUserId != null && data && data.user_id != null) {
                if (Number(data.user_id) !== Number(this.expectedUserId)) {
                    this.pin = '';
                    this.error = 'PIN não corresponde ao seu usuário.';
                    setTimeout(() => this.pinFoco(), 200);
                    return;
                }
            }
            this.pin = '';
            this.error = '';
            this.$bvModal.hide(this.modalId);
            this.$emit('validated', data || {});
            if (this.$parent && typeof this.$parent.pinResponse === 'function') {
                const uid = data && data.user_id != null ? data.user_id : this.expectedUserId;
                this.$parent.pinResponse(uid ? { id: uid, name: '' } : null);
            }
        },

        pinResponse(data) {
            const enteredPin = this.pin;
            this.pin = '';
            const user = data && (data.user || (data.id ? data : null)) ? (data.user || data) : null;

            if (user) {
                this.error = '';
                this.$bvModal.hide(this.modalId);
                if (this.$parent && typeof this.$parent.pinResponse === 'function') {
                    return this.$parent.pinResponse(user, enteredPin);
                }
            }

            this.error = (data && data.message) ? data.message : 'PIN não corresponde a nenhum usuário ou não possui permissão!';
            setTimeout(() => this.pinFoco(), 200);
        },
    },
};
</script>
